import React, { useMemo, useState, useEffect, Suspense } from "react";
import usePreloadComponents from "../hooks/usePreloadComponents";

const PreloadComponents = ({ preloadConfig }) => {
    const { isLoadRequested } = usePreloadComponents();
    const [showLazyComponents, setShowLazyComponentsCmps] = useState(true);
    const preloadList = useMemo(() => {
        return Object.values(preloadConfig).map(([_preloadConfig]) => {
            if (!_preloadConfig) return null;
            const { key, Cmp } = _preloadConfig;
            return <Cmp preload={true} key={key}></Cmp>;
        });
    }, [preloadConfig]);
    useEffect(() => {
        if (isLoadRequested) {
            setTimeout(() => {
                setShowLazyComponentsCmps(false);
            }, 1000);
        }
    }, [isLoadRequested]);
    return (
        isLoadRequested &&
        showLazyComponents && (
            <div hidden>
                <Suspense fallback={null}>{preloadList}</Suspense>
            </div>
        )
    );
};

export default React.memo(PreloadComponents);
